import React from "react";
// import Navigation from "../../components/Navigation";
import Footer from "../../components/Footer";
import './style.css';

const Privacy = () => {
  return (
    <div className="privacy-page">
      {/* <Navigation /> */}

      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="privacy-hero-container">
          <h1>Our Privacy Policy</h1>
          <p>A privacy policy explains how you collect, use, store, and protect user data.</p>
        </div>
      </section>

      {/* About Content */}
      <section className="privacy-content">
        <div className="privacy-container">
          <h1>Privacy Policy for Big Cat Graphics</h1>
            <h2>1. Introduction</h2>
            <p>We are Big Cat Graphics, and we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website hosted on <a href="https://firebase.google.com/docs/hosting">Firebase Hosting</a>.</p>

            <h2>2. Information We Collect</h2>
            <p>We collect information about you in the following ways:</p>
            <ul>
              <li><strong>Information You Provide (Contact Forms):</strong> We collect your Name, Email address, Phone number, and Address only if you voluntarily provide them via our contact form. We use Firebase to process these submissions. For more details, please visit their <a href="https://policies.google.com/privacy">Firebase Hosting Documentation</a>.</li>
              <li><strong>Data Collected Automatically (Hosting Logs):</strong> To deliver our website to you securely, our hosting provider, Google Firebase Hosting, automatically collects and stores your IP address. This is used strictly for security (e.g., preventing DDoS attacks) and diagnostic purposes.</li>
              <li><strong>Usage Data (Analytics):</strong> We use Firebase to understand how visitors interact with our site. This service may collect technical data such as browser type and pages visited. Please refer to their <a href="https://firebase.google.com/terms/data-processing-terms">Privacy Policy</a> for more information.</li>
            </ul>

            <h2>3. How We Use Your Information</h2>
            <p>We use the information we collect for the following purposes:</p>
            <ul>
              <li>Respond to your inquiries sent via our contact form.</li>
              <li>Monitor the security and performance of our website.</li>
              <li>Analyze site traffic to improve our content and services.</li>
              <li>Protect against fraudulent or illegal activity.</li>
            </ul>

            <h2>4. Cookies</h2>
            <p>Our static website does not use tracking or advertising cookies. However, Firebase Hosting may use a technical session cookie (__session) to ensure the proper delivery of site content.</p>

            <h2>5. Sharing Your Information</h2>
            <p>We do not sell your personal information. We only share data with:</p>
            <ul>
              <li><strong>Google (Firebase Hosting):</strong> To host and secure the website.</li>
              <li><strong>Our Contact/Analytics Providers:</strong> As necessary to process your messages or analyze site usage.</li>
              <li><strong>Legal Requirements:</strong> If required by law or to protect our legal rights.</li>
            </ul>

            <h2>6. Data Security & Retention</h2>
            <p>We take reasonable measures to protect your information from unauthorized access or loss.</p>
            <ul>
              <li><strong>Retention:</strong> Technical logs (like IP addresses) are typically kept by Firebase for a limited period (usually a few months) for security. We retain contact form information only as long as needed to fulfill your request.</li>
            </ul>

            <h2>7. Your Rights</h2>
            <p>Depending on your location, you may have the right to access, correct, or delete your personal data. To exercise these rights, please contact us at the email address below.</p>

            <h2>8. Children’s Privacy</h2>
            <p>Our website is not intended for children under 13, and we do not knowingly collect data from them.</p>

            <h2>9. Contact Us</h2>
            If you have any questions about this Privacy Policy, please contact us at: info@bigcatgraphics.co.za.
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Privacy;
